module.exports = {
	"id": "af",
	"name": "Africa",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.014608,
			"5": 0.014608,
			"6": 0.010956,
			"7": null,
			"8": 0.007304,
			"9": 0.01826,
			"10": 0.007304,
			"11": 0.05478,
			"12": 0.021912,
			"13": 0.003652,
			"14": 0.003652,
			"15": 0.010956,
			"16": 0.021912,
			"17": 0.029216,
			"18": 0.01826,
			"19": 0.178948,
			"20": 0.03652,
			"21": 0.025564,
			"22": 0.01826,
			"23": 0.029216,
			"24": 0.500324,
			"25": 0.040172,
			"26": 0.07304,
			"27": 0.03652,
			"28": 0.05478,
			"29": 0.058432,
			"30": 0.21912,
			"31": 0.193556,
			"32": 0.124168,
			"33": 0.251988,
			"34": 0.142428,
			"35": 0.423632,
			"36": 0.120516,
			"37": 0.131472,
			"38": 0.080344,
			"39": 0.113212,
			"40": 0.131472,
			"41": 0.157036,
			"42": 0.178948,
			"43": 1.055428,
			"44": 0.339636,
			"45": 0.193556,
			"46": 0.113212,
			"47": 0.087648,
			"48": 0.105908,
			"49": 1.256288,
			"50": 0.105908,
			"51": 0.482064,
			"52": 0.299464,
			"53": 9.400248,
			"54": 2.695176,
			"55": 0.047476,
			"56": 0.01826,
			"57": null
		},
		"firefox": {
			"2": 0.167992,
			"3": 0.043824,
			"4": 0.021912,
			"5": 0.021912,
			"6": 0.003652,
			"7": 0.010956,
			"8": 0.01826,
			"9": 0.01826,
			"10": 0.01826,
			"11": 0.032868,
			"12": 0.032868,
			"13": 0.040172,
			"14": 0.01826,
			"15": 0.20086,
			"16": 0.032868,
			"17": 0.021912,
			"18": 0.193556,
			"19": 0.03652,
			"20": 0.032868,
			"21": 0.20086,
			"22": 0.029216,
			"23": 0.189904,
			"24": 0.032868,
			"25": 0.372504,
			"26": 0.058432,
			"27": 0.058432,
			"28": 0.065736,
			"29": 0.083996,
			"30": 0.0913,
			"31": 0.094952,
			"32": 0.062084,
			"33": 0.032868,
			"34": 0.043824,
			"35": 0.051128,
			"36": 0.062084,
			"37": 0.07304,
			"38": 0.102256,
			"39": 0.076692,
			"40": 0.0913,
			"41": 0.065736,
			"42": 0.043824,
			"43": 0.251988,
			"44": 0.105908,
			"45": 0.102256,
			"46": 0.105908,
			"47": 0.544148,
			"48": 0.452848,
			"49": 3.297756,
			"50": 0.262944,
			"51": 0.010956,
			"52": null,
			"3.5": 0.007304,
			"3.6": 0.058432
		},
		"opera": {
			"9": null,
			"11": 0.007304,
			"12": 0.003652,
			"15": 0.010956,
			"16": null,
			"17": 0.007304,
			"18": 0.010956,
			"19": 0.021912,
			"20": 0.025564,
			"21": 0.029216,
			"22": 0.01826,
			"23": 0.021912,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.01826,
			"29": 0.021912,
			"30": 0.025564,
			"31": 0.014608,
			"32": 0.003652,
			"33": 0.007304,
			"34": 0.010956,
			"35": 0.01826,
			"36": 0.047476,
			"37": 0.149732,
			"38": 0.032868,
			"39": 0.025564,
			"40": 0.41998,
			"41": 0.062084,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0.167992,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.021912,
			"12.1": 0.058432
		},
		"safari": {
			"0": null,
			"4": 0.003652,
			"5": 0.171644,
			"6": 0.014608,
			"7": 0.01826,
			"8": 0.058432,
			"9": 0.051128,
			"10": 0.211816,
			"3.1": null,
			"3.2": null,
			"5.1": 0.01826,
			"6.1": 0.010956,
			"7.1": 0.01826,
			"9.1": 0.160688
		},
		"ios_saf": {
			"8": 0,
			"10": 1.44093224646,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0388314567027,
			"8.1-8.4": 0.0717394708576,
			"9.0-9.2": 0.0342243347211,
			"9.3": 0.522140491257
		},
		"android": {
			"3": 0,
			"4": 0.0790097777778,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00987622222222,
			"4.1": 0.284999555556,
			"4.2-4.3": 0.712498888889,
			"4.4": 1.63380933333,
			"4.4.3-4.4.4": 1.64791822222
		},
		"ie": {
			"6": 0.0111127008343,
			"7": 0.0296338688915,
			"8": 0.703804386174,
			"9": 0.500071537545,
			"10": 0.500071537545,
			"11": 1.3594537354,
			"5.5": null
		},
		"op_mob": {
			"0": 2.32144801099,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0644846669721
		},
		"edge": {
			"12": 0.076692,
			"13": 0.171644,
			"14": 0.222772
		},
		"ie_mob": {
			"10": 0.195298816901,
			"11": 0.795145183099
		},
		"bb": {
			"7": 0.29681575,
			"10": null
		},
		"samsung": {
			"0": 2.831654
		},
		"and_uc": {
			"0": 3.676071
		},
		"op_mini": {
			"0": 31.276465322
		},
		"and_chr": {
			"0": 15.88021
		},
		"and_ff": {
			"0": 0.076188
		}
	},
	"total": 97.3748965164
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/alt-af.json
 ** module id = 689
 ** module chunks = 0
 **/